<template>
  <div class="page-add">
    <div class="add-title">班级详情</div>
    <el-form class="form" size="small" label-position="right" label-width="auto" :rules="rules" :model="classForm"
      ref="classForm">
      <el-row>
        <el-col :span="4">
          <el-form-item label="班级名称：" prop="classYear">
            <el-date-picker class="year_style" align="center" v-model="classForm.classYear" type="year"
              value-format="yyyy" format="yyyy" placeholder="选择年份" :disabled="noEdit">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="60px" prop="classParentName">
            <el-input :disabled="noEdit" v-model="classForm.classParentName" placeholder="请输入班级名称">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主办单位：" prop="organizer">
            <el-input v-model="classForm.organizer" placeholder="请输入主办单位" :disabled="noEdit"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="办班级别：" prop="classLevel">
            <el-select class="form-select" v-model="classForm.classLevel" placeholder="请选择办班级别" :disabled="noEdit">
              <el-option v-for="item in classLevelData" :key="item.paramKey" :label="item.paramValue"
                :value="Number(item.paramKey)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班级类型：" prop="trainType">
            <!-- 切换成级联选择器 -->
            <el-cascader v-model="classForm.trainType" :options="treeCdata" :props="props" placeholder="请选择班级类型"
              style="width: 100%" @change="trainTypeChange" :disabled="noEdit">
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item class="scale" label="报名部门：" prop="enrollDeptNames">
            <el-input class="form-dept" readonly v-model="classForm.enrollDeptNames" placeholder="请选择可报名部门"
              :disabled="noEdit"></el-input>
            <el-button class="button-dept" @click="selectDep" :disabled="noEdit">选择</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12"><el-form-item label="报名时间：" prop="enrollTime" required>
            <el-date-picker unlink-panels v-model="classForm.enrollTime" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd" :disabled="noEdit">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="!checkClassType()">
        <el-col :span="12">
          <el-form-item label="报名条件：">
            <div>
              <div>
                <el-select class="form-select2" placeholder="无" multiple v-model="classForm.leaderTypeList"
                  :disabled="noEdit">
                  <el-option v-for="item in leaderTypeData" :key="item.paramKey" :label="item.paramValue"
                    :value="Number(item.paramKey)"></el-option>
                </el-select>
                <span>且</span>
              </div>
              <div>
                <el-select class="form-select2" placeholder="无" multiple v-model="classForm.userPoliticsList"
                  :disabled="noEdit">
                  <el-option v-for="item in userPoliticsData" :key="item.paramKey" :label="item.paramValue"
                    :value="Number(item.paramKey)"></el-option>
                </el-select>
                <span>且</span>
              </div>
              <el-checkbox-group v-model="classForm.supremeLeaderList" :disabled="noEdit">
                <el-checkbox border class="filter-item-statu" :label="0">党委一把手</el-checkbox>
                <el-checkbox border class="filter-item-statu" :label="1">政府一把手</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="是否与党校互通：" prop="isParty">
            <el-radio-group v-model="classForm.isParty" :disabled="!!editId">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="分组管理设置：" prop="groupSourceType">
            <el-radio-group v-model="classForm.groupSourceType" :disabled="!!editId">
              <el-radio :label="1">网院</el-radio>
              <el-radio :label="2">党校</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="报到方式：" prop="clockType" required>
            <el-radio-group v-model="classForm.clockType" disabled>
              <el-radio :label="1">浙里学习扫码报到</el-radio>
              <el-radio :label="2">党校报到</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扫码报到是否提示未分房：" label-width="200px" prop="clockEnableShowNotes" required>
            <el-radio-group v-model="classForm.clockEnableShowNotes" disabled>
              <el-radio :label="1">提示</el-radio>
              <el-radio :label="2">不提示</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="上课签到方式：" prop="signInType" required>
            <el-radio-group v-model="classForm.signInType" disabled>
              <el-radio :label="1">浙里学习扫码签到</el-radio>
              <el-radio :label="2">党校签到</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="classForm.trainType.length > 1 && classForm.trainType[1] == 24">
          <el-form-item class="relation_style" label="是否关联中网院专题班：" prop="isRelevanceZwy" required>
            <el-radio-group v-model="classForm.isRelevanceZwy" :disabled="noEdit">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="classForm.isRelevanceZwy">
          <el-form-item class="inputName_style" prop="zwySubjectName">
            <el-input placeholder="请输入关联的中网院专题班名称（确保名称完全一致）" v-model="classForm.zwySubjectName"
              :disabled="noEdit"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="classForm.isRelevanceZwy">
        <div class="tip_style">
          温馨提示：如果中网院在线学习情况未及时同步，请检查专题班名称是否与中网院一致。
        </div>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="班级专职管理员：" prop="auditUserIds">
            <el-input v-model="classForm.auditUserName" :disabled="noEdit" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row class="tag-view" v-if="!checkClassType() && tagList.length > 0">
      <el-tag :key="tag + index" v-for="(tag, index) in tagList" :disable-transitions="false" @click="tagClick(index)"
        :type="tagIndex == index ? '' : 'info'">
        {{ tag }}
      </el-tag>
    </el-row>

    <el-form class="form" size="small" label-position="right" label-width="120px" :model="childList[tagIndex]"
      ref="childClassForm">
      <el-row v-if="!checkClassType() && tagList.length > 0">
        <el-col :span="24">
          <el-form-item label="班级简称：" prop="className">
            <el-input class="class-name" :value="classForm.classYear + classForm.classParentName || ''"
              disabled></el-input>
            <el-input class="class-child-name" v-model="childList[tagIndex].className" :disabled="noEdit"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><el-form-item label="报到时间：" prop="clockTime">
            <el-date-picker unlink-panels v-model="childList[tagIndex].clockTime" type="datetimerange"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm" :disabled="noEdit" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报到地点：" prop="clockPlace">
            <el-input v-model="childList[tagIndex].clockPlace" :disabled="noEdit"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><el-form-item label="培训时间：" prop="trainTime">
            <el-date-picker unlink-panels v-model="childList[tagIndex].trainTime" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd" :disabled="noEdit">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学制：" prop="trainDays">
            <!-- @input="limitInput" -->
            <el-input v-model="childList[tagIndex].trainDays" :disabled="noEdit"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item :label="boringLabel" prop="trainPlace">
            <el-input v-model="childList[tagIndex].trainPlace" placeholder="请输入培训地点" :disabled="noEdit"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="班级简介：" prop="desc">
            <el-input :disabled="noEdit" type="textarea" rows="4" v-model="childList[tagIndex].desc"
              placeholder="请输入班级简介"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div style="width: 95%">
          <el-col :span="8">
            <el-form-item label="配图：" prop="webCover">
              <div v-if="childList[tagIndex].webCover" id="video-output" @mouseenter="showCover1 = true"
                @mouseleave="showCover1 = false">
                <img :src="childList[tagIndex].webCover" class="avatar" />
                <div v-show="showCover1" class="cover-bg">
                  <i class="el-icon-zoom-in delete" @click.stop="showViewer1 = true"></i>
                </div>
              </div>
              <div class="upload_tip">
                <p>WEB封面</p>
                <p class="img_tip">建议尺寸：1200px*600px（或2:1）</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="scale" prop="appCover">
              <div v-if="childList[tagIndex].appCover" id="video-output" @mouseenter="showCover2 = true"
                @mouseleave="showCover2 = false">
                <img :src="childList[tagIndex].appCover" class="avatar" />
                <div v-show="showCover2" class="cover-bg">
                  <i class="el-icon-zoom-in delete" @click.stop="showViewer2 = true"></i>
                </div>
              </div>
              <div class="upload_tip">
                <p>APP封面</p>
                <p class="img_tip">建议尺寸：1125px*468px（或12:5）</p>
              </div>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="承办单位：" prop="undertakeUnit">
            <take-unit @getTakeUnit="getTakeUnit" :initUnits="childList[tagIndex].undertakeUnitList" :noEdit="noEdit"
              v-if="loadFlag" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="计划人数：" prop="planStuNum">
            <el-input-number v-model="childList[tagIndex].planStuNum" :min="1" :max="1000" :step="10"
              :disabled="noEdit"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="checkClassType()">
        <el-col>
          <el-form-item class="scale" label="报名附件：" prop="enrollAttachment" :rules="[{
            required: childList[tagIndex].isAttachment,
            message: childList[tagIndex].isAttachment ? '请上传文件' : '',
            trigger: ['change'],
          }]">
            <upload :limit="1" :path="'class/attachment'" v-model="childList[tagIndex].enrollAttachment"
              :disabled="noEdit" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="checkClassType()">
        <el-col>
          <el-form-item label="需要报名附件：" prop="isAttachment">
            <el-radio-group v-model="childList[tagIndex].isAttachment" :disabled="noEdit">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row
        v-if="
          !(
            this.classForm.trainType.length > 1 &&
            (this.classForm.trainType[1] == 15 ||
              this.classForm.trainType[1] == 21)
          )
        "
      > -->
      <el-row v-if="
        !(
          this.classForm.trainType.length > 1 &&
          this.classForm.trainType[1] == 15
        ) && false
      ">
        <el-col :span="12">
          <el-form-item class="scale" label="班级联络员：" prop="liaisonUserNames">
            <el-input style="width: 100%" readonly v-model="childList[tagIndex].liaisonUserNames"
              placeholder="没有选择班级联络员" :disabled="noEdit"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="
        childList[tagIndex].classTeacherList &&
        childList[tagIndex].classTeacherList.length > 0 && false
      ">
        <el-col :span="12">
          <el-form-item class="scale" label="班主任：" prop="liaisonUserNames">
            <div v-for="item in childList[tagIndex].classTeacherList" :key="item.userId">
              {{ item.userName }}
              {{ item.roomNumber ? "-" + item.roomNumber : "" }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle form-text-center" label-width="0">
            <!-- <el-button @click="$router.back()">返回</el-button> -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 图片预览 -->
    <el-image-viewer v-if="showViewer1" :on-close="() => {
      showViewer1 = false;
    }
      " :url-list="[classForm.webCover]" />
    <el-image-viewer v-if="showViewer2" :on-close="() => {
      showViewer2 = false;
    }
      " :url-list="[classForm.appCover]" />
    <dept :defaultCheckedKeys="defaultCheckedKeys"></dept>
  </div>
</template>

<script>
import { Confirm } from "@/components/Confirm";
import {
  saveStudyClass,
  getClassOfflineInfo,
  updateStudyClass,
  treeChildVos,
} from "@/api/classOffline";
import { getDataMap } from "@/api/sysParam";
import vue from "../../../main";
import moment from "moment";
import Dept from "../../onlineClass/add/deptNew";
import Upload from "@/components/upload/index";
import rulesFactory from "@/utils/rules";
import TakeUnit from "@/views/offlineClass/add/takeUnit";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { getEnums } from "@/utils/common";

export default {
  name: "classDetail",
  components: { Dept, Upload, TakeUnit, ElImageViewer },
  data() {
    let checkEnrollTime = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error("请选择报名时间"));
      } else if (moment(value[1]) >= moment(this.classForm.trainTime[0])) {
        callback(new Error("培训开始时间必须晚于报名结束时间"));
      } else {
        callback();
      }
    };
    return {
      showCover1: false,
      showCover2: false,
      showViewer1: false,
      showViewer2: false,
      loadFlag: false,
      noEdit: true,
      props: {
        //树形
        value: "key",
        label: "name",
        children: "children",
        // checkStrictly: true,
      },
      treeCdata: [],
      boringLabel: "培训地点：",
      editId: null,
      parentId: null,
      defaultCheckedKeys: [],
      trainTypeData: [],
      classLevelData: [],
      publicData: [],
      currentPeriod: 0,
      leaderTypeData: [],
      userPoliticsData: [],
      classForm: {
        classYear: "",
        trainType: [],
        classLevel: 0,
        classParentName: "",
        organizer: "",
        enrollDeptIds: [],
        enrollDeptNames: "",
        isParty: 0, // 非党校=0 ，党校=1
        groupSourceType: 1, // 1网院 2党校
      },
      tagList: [],
      tagIndex: 0,
      childList: [
        {
          className: "",
          trainTime: [],
          clockTime: [],
          trainDays: "",
          trainPlace: "",
          desc: "",
          webCover: "",
          appCover: "",
          enrollTime: [],
          planStuNum: 1,
          undertakeUnitList: [],
          enrollAttachment: [],
          auditUserIds: [],
          isAttachment: 0, //0：否 1：是
          liaisonUserIds: [], //联络员
        },
      ],
      rules: {
        classYear: [rulesFactory.required("请选择年份")],
        classParentName: [
          rulesFactory.required("请输入班级名称"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        organizer: [
          rulesFactory.required("请选择主办单位"),
        ],
        trainType: [rulesFactory.required("请选择班级类型")],
        classLevel: [rulesFactory.required("请选择办班级别")],
        enrollDeptNames: [rulesFactory.required("请选择报名部门")],
      },
    };
  },
  created() {
    this.editId = this.$route.query.id;
    if (this.$route.query.parentId) {
      this.parentId = this.$route.query.parentId;
    }
    if (this.editId) {
      let params = { classId: this.editId };
      if (this.parentId) {
        params.parentId = this.parentId;
      }
      getClassOfflineInfo(params).then((res) => {
        if (!res || res.code != 0) return;
        let obj = Object.assign({}, res.data);
        let newChildList = [];
        if (obj && obj.childList && obj.childList.length > 0) {
          obj.childList.forEach((child, index) => {
            // 格式化时间
            child.trainTime = [child.trainStartTime, child.trainEndTime];
            child.clockTime = [child.clockStartTime, child.clockEndTime];
            child.enrollTime = [
              moment(child.enrollStartTime),
              moment(child.enrollEndTime),
            ];
            delete child.trainStartTime;
            delete child.trainEndTime;
            delete child.enrollStartTime;
            delete child.enrollEndTime;
            if (child.enrollAttachment) {
              child.enrollAttachment = JSON.parse(child.enrollAttachment);
            } else {
              child.enrollAttachment = [];
            }
            newChildList.push(child);
          });
        }
        this.childList = newChildList;
        // 处理tagList和tagIndex
        if (newChildList && newChildList.length > 0) {
          this.tagList = newChildList.map((x) => x.className);
          let index = newChildList.map((x) => x.uuid).indexOf(this.editId);
          this.tagIndex = index > -1 ? index : 0;
        }

        this.classForm = obj;
        this.loadFlag = true;
        this.defaultCheckedKeys = this.classForm.enrollDeptIds;
        treeChildVos({ type: "CLASS_TYPE_DOWN" }).then((res) => {
          if (!res || res.code != 0) return;
          let tg = this.classForm.trainType;
          let tt = [0, String(tg)];
          this.treeCdata = res.data || [];
          this.treeCdata.forEach((x) => {
            if (x.children) {
              x.children.forEach((y) => {
                if (y.key == tt[1]) {
                  tt[0] = x.key;
                }
              });
            }
          });
          this.classForm.trainType = tt;
          this.classForm.enrollTime = [
            moment(obj.enrollStartTime),
            moment(obj.enrollEndTime),
          ];
          delete this.classForm.enrollStartTime;
          delete this.classForm.enrollEndTime;

          console.log(this.classForm, tt);
        });
      });
      this.rules.classParentName = [];
    } else {
      this.loadFlag = true;
      let date = new Date();
      this.classForm.classYear = date.getFullYear().toString();
      treeChildVos({ type: "CLASS_TYPE_DOWN" }).then((res) => {
        if (!res || res.code != 0) return;
        this.treeCdata = res.data;
      });
    }
    // 获取办班级别数据字典
    getDataMap("CLASS_LEVEL_TYPE").then((res) => {
      if (!res || res.code != 0) return;
      this.classLevelData = res.data;
      if (res.data.length > 0 && !this.edit) {
        // 设置默认选中
        this.classForm.classLevel = Number(res.data[0].paramKey);
      }
    });
    getEnums(
      ["USER_LEADER_TYPE", "USER_POLITICS"],
      this,
      ["leaderTypeData", "userPoliticsData"],
      []
    );
    vue.$on("enrollDeptSelected", (dept) => {
      this.classForm.enrollDeptIds = dept.ids;
      this.defaultCheckedKeys = dept.ids;
      this.classForm.enrollDeptNames = dept.names.join(",");
    });
  },
  beforeDestroy() {
    vue.$off("enrollDeptSelected");
  },
  methods: {
    getTakeUnit(val) {
      console.log("xxxx", val);
      this.classForm.undertakeUnit = val;
    },
    trainTypeChange(val) {
      console.log(val);
      if (val[1] == 23) {
        this.boringLabel = "培训国家：";
      } else {
        this.boringLabel = "培训地点：";
      }
    },
    selectDep() {
      vue.$emit("selectDep");
    },
    handleClose(tag) {
      // 清除当前期次数据
      this.removeTrainInfoDto(this.periodTypeList.indexOf(tag));
      this.periodTypeList.splice(this.periodTypeList.indexOf(tag), 1);
    },
    // 重置表单数据
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        let classParentName = this.classForm.classParentName;
        this.$refs["classForm"].resetFields();
        this.classForm.classParentName = classParentName;
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    //新增班级
    submit() {
      this.$refs["classForm"]
        .validate()
        .then(() => {
          let params = Object.assign({}, this.classForm);
          params.trainStartTime = moment(params.trainTime[0]).format(
            "YYYY-MM-DD"
          );
          params.trainEndTime = moment(params.trainTime[1]).format(
            "YYYY-MM-DD"
          );
          delete params.trainTime;
          params.enrollStartTime = moment(params.enrollTime[0]).format(
            "YYYY-MM-DD"
          );
          params.enrollEndTime = moment(params.enrollTime[1]).format(
            "YYYY-MM-DD"
          );
          delete params.enrollTime;
          delete params.enrollDeptNames;
          params.trainType = this.classForm.trainType[1];
          params.enrollAttachment = JSON.stringify(params.enrollAttachment);
          if (!this.editId) {
            saveStudyClass(params).then((res) => {
              if (!res || res.code != 0) return;
              this.$message({
                message: "班级新增成功！",
                type: "success",
              });
              this.$router.back();
            });
          } else {
            updateStudyClass(params).then((res) => {
              if (!res || res.code != 0) return;
              this.$message({
                message: "班级修改成功！",
                type: "success",
              });
              this.$router.back();
            });
          }
        })
        .catch(() => { });
    },
    // 点击tag
    tagClick(val) {
      this.tagIndex = val;
    },
    checkClassType() {
      if (
        this.classForm.trainType.length > 1 &&
        this.classForm.trainType[1] == 15
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;

.tip_style {
  // width: 100%;
  font-size: 1rem;
  float: right;
  height: 42px;
  line-height: 42px;
  background-color: #eee;
  padding: 0 18px;
}

/deep/ .inputName_style .el-form-item__content {
  margin-left: -1rem !important;
}

/deep/ .relation_style .el-radio {
  margin-right: 16px !important;
}

/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}

/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}

.form-select {
  width: 100%;
}

/deep/ .el-form-item__content {
  .form-dept {
    width: calc(100% - 90px) !important;
    font-size: inherit;
  }

  .form-dept2 {
    width: calc(50% - 90px) !important;
    font-size: inherit;
  }

  .button-dept {
    margin-left: 10px;
    padding: 9px 15px;
    width: 79px;
  }

  .el-select.select {
    width: 100% !important;
  }
}

.year_style {
  // width: 145px;
  margin-right: 10px;
  color: #51627d;
}

/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}

.form-text-center {
  text-align: center !important;
}

/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}

/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}

.form-select {
  width: 100%;
}

.form-select2 {
  width: calc(100% - 30px);
  margin-bottom: 16px;
  margin-right: 8px;
}

/deep/ .el-form-item__content {
  .form-dept {
    width: calc(50% - 139px);
    font-size: inherit;
  }

  .button-dept {
    margin-left: 10px;
    padding: 9px 15px;
    width: 79px;
  }

  .el-select.select {
    width: 100% !important;
  }
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 280px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 280px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: $textColor;
  font-size: 13px;
}

.year_style {
  // width: 100px;
  margin-right: 10px;
  color: #51627d;
}

#video-output {
  width: 280px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 280px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.className-style {
  width: calc(100% - 110px);
}

/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}

.form-text-center {
  text-align: center !important;
}

.el-tag {
  margin-left: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.tag-view {
  margin-bottom: 20px;
  margin-top: -10px;
  padding-top: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
}

.class-name {
  width: 400px;
  margin-right: 6px;
}

.class-child-name {
  width: 200px;
  margin-left: 6px;
}
</style>
